/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import { Frame } from "../frames/frame"
import { commonTranslations } from "../translations/silos"

export const HDF_SUBREAD_FRAME = new Frame({
    endpoint: undefined, // API.nDatasets.and({$set_type: "hdfsubreads"}),
    properties: {
        name: {
            title: commonTranslations.name,
            description: "",
            type: "string",
            idField: "id",
            /* eslint no-template-curly-in-string: "off" */
            url: "/data-management/dataset-detail/${id}?type=hdfsubreads" // type = DatasetType.HDF_SUBREAD.shortName
        },
        cellIndex: {
            title: commonTranslations.cellIndex,
            description: "",
            type: "integer"
        },
        cellId: {
            title: commonTranslations.cellId,
            description: "",
            type: "string"
        },
        updatedAt: {
            title: commonTranslations.updatedAt,
            description: "",
            type: "string",
            format: "date-time"
        },
        numRecords: {
            title: commonTranslations.numRecords,
            description: "",
            type: "integer"
        },
        totalLength: {
            title: commonTranslations.totalLength,
            description: "",
            type: "integer"
        },
        createdAt: {
            title: commonTranslations.createdAt,
            description: "",
            type: "string",
            format: "date-time"
        },
        id: {
            title: commonTranslations.id,
            description: "",
            type: "string"
        },
        uuid: {
            title: commonTranslations.uuid,
            description: "",
            type: "string"
        },
        path: {
            title: commonTranslations.path,
            description: "",
            type: "string"
        },
        runName: {
            title: commonTranslations.runName,
            description: "",
            type: "string"
        },
        plateId: {
            title: commonTranslations.plateId,
            description: "",
            type: "string"
        },
        instrumentName: {
            title: commonTranslations.instrumentName,
            description: "",
            type: "string"
        },
        wellName: {
            title: commonTranslations.wellName,
            description: "",
            type: "string"
        },
        wellSampleName: {
            title: commonTranslations.wellSampleName,
            description: "",
            type: "string"
        },
        bioSampleName: {
            title: commonTranslations.bioSampleName,
            description: "",
            type: "string"
        },
        metadataContextId: {
            title: commonTranslations.metadataContextId,
            description: "",
            type: "string"
        },
        tags: {
            title: commonTranslations.tags,
            description: "",
            type: "string"
        },
        projectId: {
            title: commonTranslations.projectId,
            description: "",
            type: "integer"
        },
        jobId: {
            title: commonTranslations.jobId,
            description: "",
            type: "integer"
        },
        version: {
            title: commonTranslations.version,
            description: "",
            type: "string"
        },
        md5: {
            title: commonTranslations.md5,
            description: "",
            type: "string"
        },
        createdBy: {
            title: commonTranslations.createdBy,
            description: "",
            type: "string"
        },
        comments: {
            title: commonTranslations.comments,
            description: "",
            type: "string"
        }
    }
})
